import { useTranslation } from 'react-i18next';

import { AvatarProps } from '@mui/material';

import clsx from 'clsx';

import { ReactComponent as DefaultAvatar } from '../../assets/default-avatar.svg';
import { DEFAULT_AVATAR_ID } from '../../constants';
import { i18nNS } from '../../i18n';
import { Avatar, avatarClasses } from './styles';
import useUserAvatarVM, { VMProps } from './vm';

export interface Props extends VMProps, DistributiveOmit<AvatarProps, 'src'> {}

const UserAvatar = ({ className, variant = 'rounded', ...props }: Props) => {
  const { t } = useTranslation([i18nNS.COMMON]);
  const { avatarId } = props;
  const { loaded, avatarURL, nameInitials, handleLoad, session } = useUserAvatarVM(props);

  return (
    <Avatar
      {...props}
      variant={variant}
      src={!avatarId || avatarURL === DEFAULT_AVATAR_ID ? undefined : avatarURL}
      imgProps={{ ...props.imgProps, onLoad: handleLoad }}
      className={clsx(className, { [avatarClasses.defaultBackground]: !loaded && avatarId })}
      slotProps={{
        img: {
          alt:
            session?.avatar === avatarId
              ? t('your_profile_picture', { ns: i18nNS.COMMON })
              : t('profile_picture', { ns: i18nNS.COMMON }),
        },
      }}
    >
      {nameInitials || <DefaultAvatar />}
    </Avatar>
  );
};

export default UserAvatar;
